import type { ComponentType, LazyExoticComponent } from 'react';
import type { SvgIconComponent } from '@mui/icons-material';
import { constatPhotoTool } from './constat-photo';
import { tirageAuSortTool } from './tirage-au-sort';
import { constatAudioTool } from './constat-audio';

export interface ToolRoute {
  path: string;
  component: ComponentType | LazyExoticComponent<ComponentType>;
}

export interface ToolDefinition {
  id: string;
  name: string;
  icon: SvgIconComponent;
  /** Route d'entrée de l'outil (cible du bouton « Ouvrir l'outil » et de la flèche retour). */
  basePath: string;
  routes: ToolRoute[];
}

export const TOOLS: ToolDefinition[] = [constatPhotoTool, tirageAuSortTool, constatAudioTool];

/** Outils attribuables par un admin (panel Administration). */
export const ASSIGNABLE_TOOLS = TOOLS;

/** Outil actif selon l'URL — pour le titre dynamique de l'AppBar. */
export function getToolByPathname(pathname: string): ToolDefinition | undefined {
  return TOOLS.find((t) => pathname === t.basePath || pathname.startsWith(`${t.basePath}/`));
}
